import {
    Box,
    Button,
    CircularProgress,
    Grid,
    IconButton,
    Stack,
  } from "@mui/material";
  import React, { useRef, useState, useEffect, useCallback } from "react";
  import { useDispatch } from "react-redux";
  import CameraAltIcon from "@mui/icons-material/CameraAlt";
  import { Delete } from "@mui/icons-material";
import { callSnackBar } from "../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../utils/constants";
import { callApiAction } from "../store/actions/commonAction";
import { deletefileOrImage, uploadImage } from "../apis/file.api";
  
  const CameraCaptureComponent = ({ onChange = () => {}, onDelete = () => { }, disabled = false }) => {
    const videoRef = useRef(null);
    const canvasRef = useRef(null);
    const [cameraActive, setCameraActive] = useState(false);
    const [capturedImage, setCapturedImage] = useState(null);
    const [stream, setStream] = useState(null);
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [percentage, setPercentage] = useState(0);
    const [error, setError] = useState(false);
    const [files, setFiles] = useState("");
  
    const startCamera = async () => {
      try {
        console.log("Starting Camera...");
        const mediaStream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        console.log("Camera Started, Stream:", mediaStream);
  
        setStream(mediaStream);
        setCameraActive(true);
      } catch (error) {
        console.error("Error accessing camera:", error);
      }
    };
  
    // Stop Camera
    const stopCamera = () => {
      console.log("Stopping Camera...");
      if (stream) {
        stream.getTracks().forEach((track) => track.stop());
      }
      setCameraActive(false);
      setStream(null);
    };
  
    // Capture Image
    const captureImage = () => {
      if (!canvasRef.current || !videoRef.current) return;
  
      const canvas = canvasRef.current;
      const video = videoRef.current;
      const context = canvas.getContext("2d");
  
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
  
      // Convert to Data URL
      const imageUrl = canvas.toDataURL("image/jpeg");
      setCapturedImage(imageUrl);
  
      // Convert to File
      canvas.toBlob((blob) => {
        if (blob) {
          const file = new File([blob], "profile_image.jpg", {
            type: "image/jpeg",
          });
  
          onFileSubmit(file);
          // setFields((prev) => ({
          //   ...prev,
          //   err: "",
          //   profile_image: file,
          // }));
  
          stopCamera(); // Stop camera after capturing
        }
      }, "image/jpeg");
    };
  
    // Assign stream to video element once it is available
    useEffect(() => {
      if (cameraActive && videoRef.current && stream) {
        console.log("Setting Video Source Object...");
        videoRef.current.srcObject = stream;
      }
    }, [cameraActive, stream]);
  
    const onFileSubmit = (file) => {
      const maxSize = 1024 * 1024; // 1MB limit
      if (file?.size > maxSize) {
        dispatch(
          callSnackBar(
            "File size should be less than 1 MB",
            SNACK_BAR_VARIETNS.error
          )
        );
        setError(true);
        return;
      }
  
      setError(false);
  
      setLoading(true);
      const formData = new FormData();
      formData.append("image", file);
  
      if (false) {
        formData.append("noCompression", true);
      }
  
      dispatch(
        callApiAction(
          async () =>
            await uploadImage(formData, (progressEvent) => {
              setPercentage(
                Math.round((progressEvent.loaded * 100) / progressEvent.total)
              );
            }),
          (response) => {
            setFiles([response.url]);
            onChange(response.url, [...files, response.url]);
            setLoading(false);
            setPercentage(0);
          },
          (err) => {
            setLoading(false);
            setPercentage(0);
          }
        )
      );
    };
  
    const onDeleteFile = useCallback(
      (url, onComplete = () => {}) => {
        dispatch(
          callApiAction(
            async () => deletefileOrImage(url),
            (response) => {
              const oldList = files;
              const newList = [];
  
              for (let file of oldList) {
                if (file != url) newList.push(file);
              }
              setFiles(newList);
              onDelete(url, files);
              setCapturedImage(null);
              dispatch(
                callSnackBar(
                  "File deleted successfully.",
                  SNACK_BAR_VARIETNS.success
                )
              );
              setLoading(false);
              onComplete();
            },
            (err) => {
              onComplete();
              console.warn(err);
              dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error));
            },
            true
          )
        );
      },
      [files]
    );
  
    return (
      <div>
        {/* Camera Capture */}
        {!cameraActive && !capturedImage && (
          <Button
            onClick={startCamera}
            variant="contained"
            sx={{ mt: 2 }}
            disabled={disabled}
          >
            <CameraAltIcon />
          </Button>
        )}
  
        {/* Video Preview & Capture Buttons */}
        {cameraActive && (
          <Box mt={2}>
            {/* Video Element */}
            <video
              ref={videoRef}
              autoPlay
              playsInline
              style={{
                width: "100%",              // Responsive width
                maxWidth: "440px",          // Limits how big it can get
                aspectRatio: "4 / 3",       // Keeps video box proportionate
                borderRadius: "8px",        // Rounded corners
                objectFit: "cover",         // Crops video to fill the box neatly
                border: "1px solid #ccc",
                // width: "100%",
                // maxWidth: "100",
                // borderRadius: "5px",
              }}
            />
            <Stack direction="row" spacing={2} sx={{ mt: 1 }}>
              <Button onClick={captureImage} variant="contained" color="primary">
                Capture
              </Button>
              <Button onClick={stopCamera} variant="contained" color="error">
                Cancel
              </Button>
            </Stack>
          </Box>
        )}
  
        {/* Captured Image Preview */}
        {capturedImage && (
          <Box
            sx={{
              mt: 2,
              border: "1px solid grey",
              borderRadius: "4px",
              width: "75%",
            }}
          >
            <Box sx={{ pt: 2 }}>
              <img
                src={capturedImage}
                alt="Captured"
                style={{
                  width: "90%",
                  display: "block",
                  margin: "auto auto",
                  pt: 2,
                  // maxWidth: "300px",
                  borderRadius: "4px",
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {loading ? (
                <CircularProgress />
              ) : (
                <IconButton
                  onClick={() => {
                    setLoading(true);
                    onDeleteFile(files[0]);
                  }}
                  variant="outlined"
                  sx={{ mt: 1 }}
                >
                  <Delete color="error" />
                </IconButton>
              )}
            </Box>
          </Box>
        )}
  
        <canvas ref={canvasRef} style={{ display: "none" }} />
      </div>
    );
  };
  
  export default CameraCaptureComponent;